import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {deleteDocument, getDocuments} from "../../actions/Documents";
import {IMAGE_URL} from "../../path";

interface Document {
    id: number;
    document_name: string;
    file_path: string;
    created_at: Date | null;
    updated_at: Date | null;
    deleted_at: Date | null;
}


function ViewAll() {
    const location = useLocation();
    const [isCollapsed, setIsCollapsed] = useState(true);
    const user = location.state?.user;
    const baseURL = IMAGE_URL;
    const navigate = useNavigate();

     const [documents, setDocuments] = useState<Document[]>([]);
     useEffect(() => {
         fetchDocuments();
     }, []);

     function fetchDocuments() {
         getDocuments()
             .then(response => {
                 setDocuments(response.data);
             })
             .catch(error => {
                 console.error("Failed to fetch documents:", error);
             });
     }

     function handleCopyURL(document: Document) {
         navigator.clipboard.writeText(baseURL + document.file_path);
     }

     async function handleDelete(documentId: number) {
         const isConfirmed = window.confirm('Are you sure you want to delete this document?');

         if (isConfirmed) {
             try {
                 await deleteDocument(documentId);
                 fetchDocuments();
             } catch (error) {
                 console.error('Error deleting document:', error);
                 alert('Failed to delete document. Please try again.');
             }
         }
     }

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="content-form-button right-align">
                    <button
                        type="button"
                        className="button button-right"
                         onClick={() => navigate('/dashboard/documents/new', { state: { user } })}
                    >
                        Upload Document
                    </button>
                </div>



                <div className="table-container">
                    <table className="home-images-table">
                        <thead>
                        <tr>
                            <th style={{ width: "76%" }}>Title</th>
                            <th style={{ width: "12%" }}>Copy URL</th>
                            <th style={{ width: "12%" }}>Delete</th>
                        </tr>
                        </thead>
                        <tbody>
                        {documents.map((document) => (
                            <tr key={document.id}>
                                <td>{document.document_name}</td>

                                <td>
                                    <button className="button small" onClick={() => handleCopyURL(document)}>
                                        Copy URL
                                    </button>
                                </td>
                                <td>
                                    <button className="button small danger" style={{ color: "black" }} onClick={() => handleDelete(document.id)}>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ViewAll;
